export default __webpack_public_path__ + "static/media/044-countdown.cd86cb1a.png";